<template><div><h1 id="umsatzstatistik-nach-zeitraum" tabindex="-1"><a class="header-anchor" href="#umsatzstatistik-nach-zeitraum"><span>Umsatzstatistik nach Zeitraum</span></a></h1>
<p>Umsatzstatistik nach Zeitraum — Zeigt Umsätze und Rabatte nach Auftragsart oder Kontierung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Umsatzstatistik aus allen Aufträgen, die im eingegebenen Zeitraum von Datum - bis Datum erfasst, bzw. gebucht (fakturiert, retourniert) wurden</p>
<p>Es ist möglich, die Sortierung/Gruppierung nach Auftragsart, Ertragskonto oder Ereignis zu wählen.</p>
<p>Pfad: <code v-pre>Verkauf → Auswertungen → Umsatz nach Zeitraum und Auftragsart</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Statistik nach</dt>
<dd>Erfassungsdatum oder Buchungsdatum</dd>
<dt>von Datum</dt>
<dd>Anfangsdatum, inklusive, Muss-Eingabe</dd>
<dt>bis Datum</dt>
<dd>Enddatum, inklusive, Muss-Eingabe</dd>
<dt>Statistik nach</dt>
<dd>Auftragsart, Ereignis, Ertragskonto</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe <em>nach Auftragssart</em> beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>A-Art</td>
<td>Auftragsart</td>
</tr>
<tr>
<td>Anzahl Aufträge</td>
<td>Anzahl Fakturen in den gewählen Aufträgen. Normalerweise entspricht das der Anzahl Aufträge (wenn die gesamte Ware in einem mal geliefert werden konnte).</td>
</tr>
<tr>
<td>Umsatz</td>
<td>Brutto-Erlös pro Auftragsart = [VPreis] + [MWST] + [VK] + [Sp] - [R]</td>
</tr>
<tr>
<td>MWST</td>
<td>MWST-Betrag pro Auftragsart (MWST)</td>
</tr>
<tr>
<td>Versandkosten</td>
<td>Versandkosten pro Auftragsart (VK)</td>
</tr>
<tr>
<td>Spenden</td>
<td>Spenden pro Auftragsart (Sp)</td>
</tr>
<tr>
<td>Rabatt</td>
<td>Gewährte Rabatte pro Auftragsart (R)</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line"></span>
<span class="line">Umsätze von fakturierten Aufträgen mit Erfassungsdatum: 07.05.1997 - 10.11.1997</span>
<span class="line"></span>
<span class="line">A-         Anzahl          Umsatz              Versand-</span>
<span class="line">Art      Aufträge  (MWST,VK,Sp,R)       MWST   kosten      Spenden     Rabatt</span>
<span class="line">------ ---------- --------------- ---------- ---------- ---------- ----------</span>
<span class="line">aaa             3           88.00       3.90       8.40       0.00       0.00</span>
<span class="line">bbb             3           14.00       0.85       8.45       0.00       0.00</span>
<span class="line">cc             32        2,263.40     118.80      83.15      13.50      69.50</span>
<span class="line">dd             17          178.50       9.50      33.80       0.00       0.00</span>
<span class="line">eee             7       -5,096.20    -308.80      12.60       0.00 ??????????</span>
<span class="line">fff            19          742.00      45.50       0.00       0.00       0.00</span>
<span class="line"></span>
<span class="line">TOTAL          81       -1,810.30    -130.25     146.40      13.50 ??????????</span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Für die Auftragsart cc wurden 32 Fakturen generiert, und zwar für Aufträge mit Erfassungsdatum 7.5 - 10.11.1997. Der Fakturabetrag belief sich total auf 2'263.40 CHF.</p>
<p>Die Ausgabe <em>nach Ertragskonto</em> beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Ertragskonto</td>
<td>Ertragskonto und Kostenstelle</td>
</tr>
<tr>
<td>Artikel</td>
<td>Artikelnummer und -Bezeichnung</td>
</tr>
<tr>
<td>Anzahl Artikel</td>
<td>Anzahl effektiv verkaufte Artikel (Anzahl verkaufte - Anzahl Retouren)</td>
</tr>
<tr>
<td>Umsatz gemäss VPreis</td>
<td>Brutto-Umsatz gemäss Verkaufspreis des Artikels</td>
</tr>
<tr>
<td>Warenerlös</td>
<td>Netto-Erlös pro Artikel</td>
</tr>
<tr>
<td>Rabatt</td>
<td>gewährte Rabatte pro Artikel</td>
</tr>
<tr>
<td>MWST</td>
<td>verrechneter MWST-Betrag pro Artikel</td>
</tr>
<tr>
<td>Total (Waren,R,MWST)</td>
<td>Das Total ergibt sich aus Warenerlös + Rabatt + MWSt.</td>
</tr>
</tbody>
</table>
<p>Für jede Konto/Kostenstellen-Kombination werden zusätzlich Gruppentotale angegeben.</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line"></span>
<span class="line">Umsätze von fakturierten Aufträgen mit Erfassungsdatum: 07.05.1997 - 10.11.1997</span>
<span class="line"></span>
<span class="line">                                        Anzahl   Umsatz gemäss                                                      Total</span>
<span class="line">Ertragskonto/Artikel                   Artikel          VPreis      Warenerlös          Rabatt       MWST (Waren.,R,MWST)</span>
<span class="line">----------------------------------- ---------- --------------- --------------- --------------- ---------- ---------------</span>
<span class="line"></span>
<span class="line">Konto 3999 12345</span>
<span class="line">    UF6678 Artikel Beispiel                  2           64.00           62.80            0.00       1.20           64.00</span>
<span class="line">    ZF6679 Noch ein Beispiel                 3          117.00          114.75            0.00       2.25          117.00</span>
<span class="line">Total für Konto 3999 12345                              181.00          177.55            0.00       3.45          181.00</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Unter den betrachteten Aufträgen (Erfassungsdatum 7.5. - 10.11.97) wurden insgesamt -5 Artikel 1B verkauft.</p>
<div class="hint-container tip">
<p class="hint-container-title">Anmerkung</p>
<p>Falls die Kontierung eines Artikels während der betrachteten Periode geändert hat, dann wird der gesamte Artikelumsatz im <span class="emphasis"><em>aktuellen </em></span>Konto geführt.</p>
</div>
<div class="hint-container tip">
<p class="hint-container-title">Anmerkung</p>
<p>Spendeartikel werden in dieser Statistik separat aufgelistet.</p>
</div>
</div></template>


